import type { SupportedPlatforms } from '@smg-real-estate/domus';

import { HgSupportedLanguage } from '@smg-real-estate/domus';
import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';

const HgPageNotFound = () => import('@smg-real-estate/domus/HgPageNotFound.vue');

export const PAGE_NOT_FOUND = 'pageNotFound';

function generatePageNotFoundRoutes(platform: SupportedPlatforms): RouteRecordRaw[] {
  return [
    HgSupportedLanguage.DE,
    HgSupportedLanguage.EN,
    HgSupportedLanguage.FR,
    HgSupportedLanguage.IT,
  ].map((locale) => ({
    path: '/:pageNotFound(.*)*',
    name: `${PAGE_NOT_FOUND}-${locale}`,
    component: HgPageNotFound,
    props: {
      theme: platform,
    },
    meta: {
      locale: locale,
      defaultLocale: HgSupportedLanguage.DE,
      getLanguageSwitchLink(route: RouteLocationNormalized, language: HgSupportedLanguage) {
        return {
          name: `${PAGE_NOT_FOUND}-${language}`,
          query: route.query,
          params: route.params,
          path: route.path,
        };
      },
    },
  }));
}

export default generatePageNotFoundRoutes;
